module.exports = __webpack_public_path__ + "static/img/alien-organs_256.fb2071b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/alien-organs_256.png
// module id = +0Py
// module chunks = 0